<template>
  <section class='section'>
    <!-- Table -->
    <table-ag ref='tableEmployeesCl7' :row-data='employees' :column-defs='columns' :components='components' :component-menu='componentMenu' :actions='true'></table-ag>
  </section>
</template>
<script>
import apiServices from '@/services/yungol-services'
import tableAg from "../dashboard/tableAg.vue";
import MenuTableSurvey from "./components/menuTableSurvey.vue";
import ButtonsActionSurvey from "./components/ButtonsActionSurvey.vue";
export default {
  data(){
    return {
      employees: [],
      columns:[
        {
          field: 'nombre',
          headerName:'Nombre',
          tooltipValueGetter: params => { return params.value },
          editable: false,
          def: true
        },
        {
          field: 'cedula',
          headerName:'Cédula',
          editable: false,
          def: true
        },
        {
          field: 'email',
          headerName:'Correo',
          editable: false,
          def: true
        },
        {
          field: 'status',
          headerName:'Estado',
          width: 90,
          cellRenderer: params => {return this.formatStatus(params)},
          cellStyle: {
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            'padding-right': '5'
          },
          editable: false,
        },
        {
          field: '_id',
          headerName:'Controles',
          colId: '_actions',
          editable: false,
          def: true,
          cellRenderer: 'ButtonsActionSurveyCl7',
          sortable: false,
          width: 150,
        }
      ],
      componentMenu: () => {
        return {
          render: h => h(MenuTableSurvey, {
            props: {
              employees: this.employees,
              proceso: this.proceso,
            },
            on:{
              calculateAll: this.calculateAll,
              getEmployees: this.getEmployees,
              widthCols: this.widthCols
            }
          })
        };
      },
      components: {
        ButtonsActionSurveyCl7: () => {
          return {
            render: h => h(ButtonsActionSurvey, {
              props: {
                proceso: this.proceso
              },
              on:{
                getEmployees: this.getEmployees,
                widthCols: this.widthCols
              }
            })
          };
        },
      },
    }
  },
  props:{
    proceso: Object
  },
  computed:{},
  beforeMount() {
  },
  methods:{
    // Table
    async getEmployees() {
      try {
        const result = await apiServices.get(
            `/employeesclima/${this.proceso._id}`
        );
        if (result.data) {
          this.employees = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async calculateAll() {
      try {
        await apiServices.post(`/calculateallemployeeclima`, {
          proceso: this.proceso._id,
        });
        await this.getEmployees();
      } catch (err) {
        console.log(err);
      }
    },
    // Actions
    // Others
    formatStatus(p){
      const v = p.value.toLowerCase()
      if (p.data.responses && !p.data.responses.agree){
        return `<span class="tag is-info is-capitalized" style='width: 100% !important;'>Desacuerdo</span>`
      }
      if (v === 'calculado'){
        return `<span class="tag is-success is-capitalized" style='width: 100% !important;'>${v}</span>`
      }
      /* if (p.data.responses && (Object.keys(p.data.responses).length > 2 || p.data.responses.agree)){
        return `<span class="tag is-link is-capitalized" style='width: 100% !important;'>En proceso</span>`
      } */
      if (v === "terminada"){
        return `<span class="tag is-link is-capitalized" style='width: 100% !important;'>${v}</span>`
      }
      if (v === "proceso"){
        return `<span class="tag is-dark is-capitalized" style='width: 100% !important;'>En proceso</span>`
      }
      if (v === "enviado"){
        return `<span class="tag is-warning is-capitalized" style='width: 100% !important;'>${v}</span>`
      }
      if (v === "creada"){
        return `<span class="tag is-grey is-capitalized" style='width: 100% !important;'>${v}</span>`
      }
    },
    widthCols(data) {
      let values = []
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = {width: (String(data[i][d]).length + 2)}
            values.push(w)
          }
              //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = (String(data[i][d]).length + 2)
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = (String(key).length + 2)
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values
    },
  },
  created() {
    this.calculateAll();
  },
  watch:{},
  components:{tableAg}
}
</script>
<style lang="scss">
.ag-header-cell-label {
  justify-content: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/climan/Surveys.vue